import React, { useState } from 'react'
import { useRequest } from 'ahooks'
import { GoodsTableList } from '../goods-table'
import { IPagination } from '@/model/types/common'
import { Goods } from '@/model/types/goods'
import { $post } from '@/api'
import { errorCallBack, isExist } from '@/utils'
import { isNoMore, WithScrollLoad } from '@/utils/utils-widget'
import useBemClass from '@/utils/hooks/useBEMClass'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage } from '@/utils/layer'
import { Column, Row } from '@/components/layout/layout'
import classnames from 'classnames'
import { Spin } from 'antd'
import { priceMethodType } from '../../edit-goods/modules/form/sale-price/sale-price'
import Button from '@/components/button/button'
import BatchPriceEdit, { BatchMemberPriceEdit, BatchUnitEdit } from './batch-price-edit'
import $msg from '@/utils/message'
import { goodsLibraryStore } from '../../../store/goods-library'

interface BatchPriceCustomProps {
    goodIds: number[]
}

const BatchPriceCustom: React.FC<BatchPriceCustomProps> = props => {
    const cls = useBemClass('batch-price')

    const [goodList, setGoodList] = useState<any[]>([])

    const requestHandle = useRequest<
        GoodsTableList,
        {
            goods_list: Goods[]
            pagination: IPagination
        }
    >(
        val =>
            $post({
                url: '/goods/getgoods',
                params: {
                    limit: 20,
                    goods_ids: props.goodIds,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                },
            }),
        {
            isNoMore: isNoMore,
            onError: errorCallBack,
            loadMore: true,
            onSuccess: r => {
                setGoodList(val =>
                    val.concat(
                        r.list.map(g => ({
                            id: g.id,
                            goods_package: g.goods_package,
                            sales_unit: g.sales_unit,
                            secondary_group: g.secondary_group,
                            group: g.group,
                            name: g.name,
                            pricing_methods: g.pricing_methods.map(p => {
                                return {
                                    ...p,
                                    sale_prices: p.sale_prices.map(sale => ({
                                        ...sale,
                                        new_sale_price: sale.sale_price,
                                        new_threshold: sale.threshold,
                                    })),
                                    member_price: isExist(p.member_price)
                                        ? {
                                              ...p.member_price,
                                              new_sale_price: p.member_price.sale_price,
                                          }
                                        : {
                                              new_sale_price: null,
                                              sale_price: null,
                                              sale_unit: g.sales_unit,
                                          },
                                }
                            }),
                        })),
                    ),
                )
            },
            formatResult: data => {
                return {
                    list: data.goods_list,
                    pagination: data.pagination,
                }
            },
        },
    )

    const batchReq = useRequest(
        (r: any[]) =>
            $post({
                url: '/goods/onekeyeditgoodspricingmethod',
                params: {
                    pricing_methods: r,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                layerManage.pop()
                $msg('success', '处理成功')
                goodsLibraryStore.setUpdateGroupStatus()
            },
            onError: errorCallBack,
        },
    )

    return (
        <BaseDialog isShow title="批量自定义改价" onClose={() => layerManage.pop()}>
            <Column data-width-100p data-padding-h-20>
                <Column data-margin-top-17 className={cls('table')}>
                    <Row>
                        <div className={classnames(cls('top'), cls('top', '0'))}>类型</div>
                        <div className={classnames(cls('top'), cls('top', '1'))}>计价单位</div>
                        <div className={classnames(cls('top'), cls('top', '2'))}>售价</div>
                        <div className={classnames(cls('top'), cls('top', '3'))}>会员价</div>
                    </Row>
                    <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                        <Spin spinning={requestHandle.loading || requestHandle.loadingMore}>
                            <Column className={cls('content')}>
                                {goodList.map((good, goodIndex) => (
                                    <Column key={good.id}>
                                        <Row
                                            data-padding-h-8
                                            data-color-999
                                            data-font-size-12
                                            data-align-items-center
                                            data-height-30
                                            data-justify-content-space-between
                                            className={cls('top-line')}
                                        >
                                            <Row>
                                                #{goodIndex + 1}
                                                {isExist(good.goods_package) && (
                                                    <div className={cls('package')}>套</div>
                                                )}
                                                <span data-margin-left-4 className={cls('content', 'title')}>
                                                    {good.name}
                                                </span>
                                            </Row>
                                            <div>
                                                {good.group.name}
                                                {isExist(good.secondary_group) && (
                                                    <span>/{good.secondary_group.name}</span>
                                                )}
                                            </div>
                                        </Row>
                                        {good.pricing_methods.map((price: any, index: number) => (
                                            <Row key={price.id}>
                                                <div className={classnames(cls('line'), cls('line', '0'))}>
                                                    <div
                                                        className={classnames(
                                                            cls('price-type'),
                                                            cls(`price-type`, priceMethodType[price.method_type].style),
                                                        )}
                                                    >
                                                        {priceMethodType[price.method_type].txt}
                                                    </div>
                                                </div>
                                                <div
                                                    data-cursor-pointer
                                                    className={classnames(cls('line'), cls('line', '1'))}
                                                >
                                                    <BatchUnitEdit
                                                        unit={price.sales_unit}
                                                        onChange={unit => {
                                                            setGoodList(val => {
                                                                const tmp = val[goodIndex].pricing_methods.slice()
                                                                tmp[index] = {
                                                                    ...tmp[index],
                                                                    sale_prices: tmp[index].sale_prices.map(
                                                                        (s: any) => ({
                                                                            ...s,
                                                                            sale_unit: unit.id,
                                                                        }),
                                                                    ),
                                                                    member_price: isExist(tmp[index].member_price)
                                                                        ? {
                                                                              ...tmp[index].member_price,
                                                                              sale_unit: unit.id,
                                                                          }
                                                                        : tmp[index].member_price,
                                                                    sales_unit: {
                                                                        ...unit,
                                                                        old_id: tmp[index].sales_unit.id,
                                                                    },
                                                                }
                                                                val[goodIndex] = {
                                                                    ...val[goodIndex],
                                                                    pricing_methods: tmp,
                                                                }

                                                                return val
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className={classnames(cls('line'), cls('line', '2'))}>
                                                    <BatchPriceEdit
                                                        salePrices={price.sale_prices}
                                                        onChange={price => {
                                                            console.info(price)
                                                            setGoodList(val => {
                                                                const tmp = val[goodIndex].pricing_methods.slice()
                                                                tmp[index] = {
                                                                    ...tmp[index],
                                                                    sale_prices: price,
                                                                }
                                                                val[goodIndex] = {
                                                                    ...val[goodIndex],
                                                                    pricing_methods: tmp,
                                                                }

                                                                return val
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className={classnames(cls('line'), cls('line', '3'))}>
                                                    <BatchMemberPriceEdit
                                                        memberPrice={price.member_price}
                                                        maxValue={
                                                            price.sale_prices[price.sale_prices.length - 1].sale_price
                                                        }
                                                        onChange={price => {
                                                            setGoodList(val => {
                                                                const tmp = val[goodIndex].pricing_methods.slice()
                                                                tmp[index] = {
                                                                    ...tmp[index],
                                                                    member_price: price,
                                                                }
                                                                val[goodIndex] = {
                                                                    ...val[goodIndex],
                                                                    pricing_methods: tmp,
                                                                }

                                                                return val
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </Row>
                                        ))}
                                    </Column>
                                ))}
                            </Column>
                        </Spin>
                    </WithScrollLoad>
                </Column>

                <Row data-justify-content-flex-end data-margin-v-20>
                    <Button
                        types="default"
                        loading={batchReq.loading}
                        onClick={() => {
                            const r = goodList.reduce((pre, next) => {
                                const tmp = next.pricing_methods.map((price: any) => {
                                    const newPrice: Record<string, any> = {}
                                    if (isExist(price.member_price.new_sale_price)) {
                                        if (
                                            +price.member_price.new_sale_price !== price.member_price.sale_price ||
                                            price.member_price.sale_unit.id !== price.sales_unit.id
                                        ) {
                                            newPrice.member_price = {
                                                sale_price: +price.member_price.new_sale_price,
                                                sale_unit: price.sales_unit.id,
                                            }
                                        }
                                    }
                                    const newSalePrice = price.sale_prices.map((p: any) => {
                                        return {
                                            sale_price: +p.new_sale_price,
                                            threshold: +p.new_threshold,
                                            sale_price_id: p.id || void 0,
                                            sale_unit: price.sales_unit.id,
                                        }
                                    })

                                    if (isExist(newSalePrice)) {
                                        newPrice.sale_prices = newSalePrice
                                    }
                                    if (price.sales_unit.id !== price.sales_unit.old_id && !!price.sales_unit.old_id) {
                                        newPrice.sales_unit_id = price.sales_unit.id
                                    }
                                    if (isExist(newPrice)) {
                                        newPrice.id = price.id
                                        newPrice.sales_unit_id = price.sales_unit.id
                                        newPrice.sales_unit_ratio = price.sales_unit_ratio
                                    }

                                    return newPrice
                                })

                                return [...pre, ...tmp].filter(v => isExist(v))
                            }, [])
                            batchReq.run(r)
                        }}
                    >
                        确认改价
                    </Button>
                </Row>
            </Column>
        </BaseDialog>
    )
}

export default BatchPriceCustom
